import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import { SECRET_KEY } from "../Constants/Config";
import { getPersistedSessionLoginId } from "./persistedLoginId";

const navigateToListingPage = () => {
  let url = window.location.pathname;
  let redirectedPage;
  const value = url.split("").toReversed().join("")?.split("/")[0];
  const isNumber = Boolean(!isNaN(value));
  if (url.includes("/inventory/products/edit")) {
    redirectedPage = "/inventory/new-products";
  } else if (url.includes("/inventory/category/edit-category")) {
    redirectedPage = "/inventory/category";
  } else if (url.includes("/inventory-merge")) {
    redirectedPage = "/inventory/new-products";
  } else if (url.includes("/purchase-order/add")) {
    redirectedPage = "/purchase-order";
  } else if (url.includes("/purchase-order") && isNumber) {
    redirectedPage = "/purchase-order";
  } else if (url.includes("/promotions/coupons/edit-coupons")) {
    redirectedPage = "/promotions/coupons";
  } else if (url.includes("/promotions/bogo-pricing/add")) {
    redirectedPage = "/promotions/bogo-pricing";
  } else if (url.includes("/mix-and-match/update")) {
    redirectedPage = "/mix-and-match";
  } else if (url.includes("/customer/addCustomer?customer_id")) {
    redirectedPage = "/customer";
  } else if (url.includes("/customer/editCustomer")) {
    redirectedPage = "/customer";
  } else if (url.includes("/inventory/old-vendors/edit-vendor")) {
    redirectedPage = "/inventory/old-vendors";
  } else {
    redirectedPage = "";
  }

  return redirectedPage;
};

export const getAuthDetails = () => {
  let AuthFinalLogin =
    Cookies.get("loginDetails") !== undefined
      ? Cookies.get("loginDetails")
      : [];
  let LoginGetDashBoard =
    Cookies.get("token_data") !== undefined ? Cookies.get("token_data") : [];

  const AdminRocordNew = CryptoJS.AES.decrypt(
    AuthFinalLogin,
    SECRET_KEY
  ).toString(CryptoJS.enc.Utf8);
  let LoginAllStore = AdminRocordNew !== "" ? JSON.parse(AdminRocordNew) : "";

  let LoginGetDashBoardRecord = CryptoJS.AES.decrypt(
    LoginGetDashBoard,
    SECRET_KEY
  ).toString(CryptoJS.enc.Utf8);
  let LoginGetDashBoardRecordJson =
    LoginGetDashBoardRecord !== "" ? JSON.parse(LoginGetDashBoardRecord) : "";

  // console.log("LoginGetDashBoardRecordJson", LoginGetDashBoardRecordJson);

  const token_id = LoginGetDashBoardRecordJson?.token_id;
  const login_type = LoginGetDashBoardRecordJson?.login_type;
  const token = LoginGetDashBoardRecordJson?.token;
  const user_id = LoginGetDashBoardRecordJson?.data?.id;
  const session_id = LoginGetDashBoardRecordJson?.data?.id;
  // Store the user is currently logged into (distinct from request merchant_id,
  // which may intentionally target another store e.g. inventory export).
  const login_merchant_id = LoginGetDashBoardRecordJson?.data?.merchant_id;
  const persistedSessionLoginId = getPersistedSessionLoginId();
  const toSessionLoginId = (v) => {
    if (v == null || v === "") return null;
    const s = String(v).trim();
    return s !== "" ? s : null;
  };
  const employeeIdFromToken = toSessionLoginId(
    LoginGetDashBoardRecordJson?.employee_id
  );
  const dataIdFromToken = toSessionLoginId(
    LoginGetDashBoardRecordJson?.data?.id
  );
  const session_login_id =
    persistedSessionLoginId ?? employeeIdFromToken ?? dataIdFromToken;
  const inventory_approval =
    LoginGetDashBoardRecordJson?.data?.inventory_approval;
  const future_ordering = LoginGetDashBoardRecordJson?.data?.future_ordering;
  const future_day_count = LoginGetDashBoardRecordJson?.data?.future_day_count;
  const future_date = future_ordering === "1" ? future_day_count : null;
  let userTypeData = {
    token_id,
    login_type,
    // Same value as login_type: the role this session signed in as
    // (merchant, admin, employee, superadmin). Sent on API calls as its own key.
    login_user_type: login_type,
    token,
    session_id,
    login_merchant_id,
  };

  const userTypeDataLog = {
    session_login_id,
  };

  //  ------------  username and password save data-----------------
  let UserLoginDataStringFy =
    Cookies.get("user_auth_record") !== undefined
      ? Cookies.get("user_auth_record")
      : [];
  const getUserLoginAuth = atob(UserLoginDataStringFy);
  const GetSessionLogin =
    getUserLoginAuth !== "" ? JSON.parse(getUserLoginAuth) : [];
  // Person who signed in. Superadmin sessions use the dashboard email;
  // everyone else uses the login username, then the POS login email, then
  // the store address. The interceptor only sends this when a call omitted it.
  const sessionUsername =
    typeof GetSessionLogin?.username === "string"
      ? GetSessionLogin.username.trim()
      : "";
  const storeEmail = String(LoginGetDashBoardRecordJson?.data?.email || "").trim();
  const posLoginEmail = String(LoginGetDashBoardRecordJson?.login_email || "").trim();
  userTypeData.login_user_email =
    login_type === "superadmin"
      ? storeEmail || sessionUsername || posLoginEmail
      : sessionUsername || posLoginEmail || storeEmail;
  //  --------------------------------------------------------------
  let storeData = [];
  try {
    const allStoreRaw = localStorage.getItem("AllStore");
    if (allStoreRaw) {
      const parsed = JSON.parse(allStoreRaw);
      if (Array.isArray(parsed)) {
        storeData = parsed;
      }
    } else {
      // If AllStore is missing in localStorage but present in decrypted auth,
      // hydrate it back into localStorage to avoid blank-page issues.
      const storesFromAuth =
        LoginAllStore?.data2?.stores || LoginAllStore?.data?.stores;
      if (Array.isArray(storesFromAuth) && storesFromAuth.length > 0) {
        storeData = storesFromAuth;
        try {
          localStorage.setItem("AllStore", JSON.stringify(storesFromAuth));
        } catch (e) {
          // Ignore storage write errors
        }
      }
    }
  } catch (e) {
    // If parsing fails, fall back to empty array
    storeData = [];
  }

  // ---------------------------------------------------------------

  return {
    LoginGetDashBoardRecordJson,
    LoginAllStore,
    userTypeData,
    userTypeDataLog,
    GetSessionLogin,
    user_id,
    inventory_approval,
    future_date,
    storeData,
  };
};

export const useAuthDetails = () => {
  return getAuthDetails();
};

const THEME_COOKIE_NAMES = new Set([
  "qv_theme",
  "qv_theme_flavor",
  "qv_light_tone",
]);

// Appearance cookies must not look like an auth change. The theme picker
// writes them on every tone switch; treating that as a session change
// navigates add/edit pages back to their list (a full reload).
function cookieSignature(cookie) {
  return cookie
    .split(";")
    .map((part) => part.trim())
    .filter((part) => {
      if (!part) return false;
      const name = part.split("=")[0];
      return !THEME_COOKIE_NAMES.has(name);
    })
    .sort()
    .join("; ");
}

function listenCookieChange(callback, interval = 1000) {
  let lastSignature = cookieSignature(document.cookie);

  setInterval(() => {
    const cookie = document.cookie;
    const signature = cookieSignature(cookie);

    if (signature !== lastSignature) {
      try {
        const authData = getAuthDetails();
        const redirectUrl = navigateToListingPage();
        if (redirectUrl) {
          window.location.href = process.env.PUBLIC_URL + redirectUrl;
        } else {
          const safeRoutes = ["/", "/users/unapprove"]; // Add more page route here if needed to avoid refresh page unnecessary.
          const currentPath = window.location.pathname;

          if (!safeRoutes.includes(currentPath)) {
            // window.location.reload();
          }
        }

        if (callback) callback(authData);
      } finally {
        lastSignature = signature;
      }
    }
  }, interval);
}

listenCookieChange((authData) => {
  // console.log("Auth Updated:", authData);
});
